<template>
  <div v-cloak>
    <div class="vx-card mb-4">
      <div class="vx-card__collapsible-content vs-con-loading__container">
        <div class="vx-card__body card-body">
          <div class="vx-row">
            <div class="vx-col w-full">
              <form>
                <div class="vx-row mb-4">
                  <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
                    <label class="vs-select--label datepicker-lb">{{
                      $t("FromDate")
                    }}</label>
                    <date-picker v-model="gridSearchData.FromDate" type="datetime" format="jYYYY-jMM-jDD HH:mm:ss"
                      display-format="jYYYY-jMM-jDD HH:mm:ss" class="date-picker" :label="$t('FromDate')"
                      :clearable="true" />
                  </div>
                  <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
                    <label class="vs-select--label datepicker-lb">{{
                      $t("ToDate")
                    }}</label>
                    <date-picker v-model="gridSearchData.ToDate" type="datetime" format="jYYYY-jMM-jDD HH:mm:ss"
                      display-format="jYYYY-jMM-jDD HH:mm:ss" class="date-picker" :label="$t('ToDate')"
                      :clearable="true" />
                  </div>
                  <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 my-2 w-full">
                    <label class="vs-input--label">{{
                      $t("GenericProduct")
                    }}</label>
                    <div class="w-full">
                      <v-select label="name" name="cat" :options="allGenericProducts" :reduce="x => x.id"
                        v-model="gridSearchData.genericProductIds" :multiple="true" v-validate="'required'" dir="rtl"
                        placeholder="انتخاب محصولات">
                      </v-select>
                    </div>
                  </div>
                  <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 my-1 w-full">
                    <label class="vs-input--label">{{ $t("Brand") }}</label>
                    <div class="w-full">
                      <v-select label="name" name="brand" :options="allBrands" :reduce="x => x.id"
                        v-model="gridSearchData.brandIds" :multiple="true" v-validate="'required'" dir="rtl"
                        placeholder="انتخاب برندها">
                      </v-select>
                    </div>
                  </div>
                  <div class="lg:w-full md:w-2/3 w-full mt-6 px-2">
                    <vs-button type="filled" class="float-right" @click.prevent="submitFilter()">{{ $t("SubmitFilter")
                    }}</vs-button>
                    <vs-button type="filled" class="float-right ml-4" id="reset-btn" @click.prevent="resetForm">{{
                      $t("ResetFilter") }}</vs-button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-card mb-4">
      <div class="vx-card__collapsible-content vs-con-loading__container">
        <div class="vx-card__body card-body">
          <div class="vx-row">
            <div class="vx-col w-full mb-base best-sellers-grid-container">
              <data-grid ref="grid" stripe :data-source="gridDataSource" :search-data="gridSearchData" :columns="[
                { title: $t('OrderId'), name: 'OrderId' },
                { title: $t('ProductName'), name: 'ProductName' },
                { title: $t('ItemCode'), name: 'ItemCode' },
                { title: $t('Count'), name: 'Count' },
                { title: $t('UnitPrice'), name: 'UnitPrice' },
                { title: $t('TotalAmount'), name: 'TotalAmount' },
                { title: $t('SumOfDiscount'), name: 'SumOfDiscount' },
                { title: $t('TotalTaxAmount'), name: 'TotalTaxAmount' },
                { title: $t('TotalAmountWithTax'), name: 'Price' },
                { title: $t('MoreDetails'), name: 'MoreDetails' }
              ]">
                <template slot-scope="{ row }">
                  <td style="width: 7%">
                    {{ row.id }}
                  </td>
                  <td style="width: 20%">
                    {{ row.orderProductInfoQuery.productName }}
                  </td>
                  <td style="width: 9%">
                    {{ row.orderProductInfoQuery.itemCode }}
                  </td>
                  <td style="width: 5%">
                    {{ row.count }}
                  </td>
                  <td style="width: 11%">
                    {{ Number(row.unitPrice).toLocaleString() }} ریال
                  </td>
                  <td style="width: 14%">
                    {{ Number(row.totalAmount).toLocaleString() }} ریال
                  </td>
                  <td style="width: 10%">
                    <span v-if="row.sumOfDiscount">
                      {{ Number(row.sumOfDiscount).toLocaleString() }} ریال
                    </span>
                    <span v-else> - </span>
                  </td>
                  <td style="width: 11%">
                    {{ Number(row.totalTaxAmount).toLocaleString() }} ریال
                  </td>
                  <td style="width: 15%">
                    {{ Number(row.price).toLocaleString() }} ریال
                  </td>
                  <td style="width:8%">
                    <vs-button radius color="success" size="small" type="gradient" icon-pack="feather" icon="icon-edit"
                      @click.prevent="showDetails(row)" class="mx-4 d-inline"></vs-button>
                  </td>
                </template>
              </data-grid>
            </div>
          </div>
          <details-popup :show="onShowDetails" :currentRow="currentRow" @finish="finish"></details-popup>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
#reset-btn {
  margin-left: 1.5rem;
  background: #3ec9d6 !important;
}

.best-sellers-grid-container .vs-con-table td {
  padding: 4px !important;
}

.best-sellers-grid-container .vs-con-table .vs-con-tbody .vs-table--tbody-table {
  font-size: 0.95rem !important;
}

/* هر دو ردیف مجموع */
.best-sellers-grid-container .total-row td {
  position: sticky !important;
  background-color: #007470 !important;
  color: white !important;
  z-index: 10 !important;
}

/* مجموع */
.best-sellers-grid-container .total-row:not(:last-child) td {
  bottom: 40px !important;
}

/* مجموع کل */
.best-sellers-grid-container .total-row:last-child td {
  bottom: 0 !important;
  z-index: 11 !important;
}
</style>
<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import vSelect from "vue-select";
import DetailsPopup from "../DetailsPopup.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "saleManagement_Reports_Contract_BestSellers_Index",

  props: {
    contractId: {
      default: {}
    }
  },
  computed: {
    ...mapGetters({
      allBrands: "brand/list",
      allGenericProducts: "genericProduct/list"
    })
  },
  data() {
    return {
      onShowDetails: false,
      currentRow: {},
      gridDataSource: {
        type: "app",
        service: "Sales/api/OrdersQuery/orderItems/"
      },
      gridSearchData: {
        SortingFieldName: "Count",
        SortingOrderType: "desc",
        contractId: this.contractId,
        genericProductIds: [],
        brandIds: [],
        FromDate: "",
        ToDate: ""
      }
    };
  },
  mounted() {
    this.fetchBrands();
    this.fetchGenericProducts();
  },
  methods: {
    ...mapActions({
      fetchGenericProducts: "genericProduct/fetchNoSkip",
      fetchBrands: "brand/fetchNoSkip"
    }),
    submitFilter() {
      this.$refs.grid.renderGrid(1, true);
    },
    resetForm() {
      this.gridSearchData = {
        FromDate: "",
        ToDate: "",
        SortingFieldName: "Count",
        SortingOrderType: "desc",
        contractId: this.contractId,
        genericProductIds: [],
        brandIds: []
      };

      setTimeout(() => {
        this.$refs.grid.renderGrid(1, true);
      }, 0);
    },
    showDetails(row) {
      this.currentRow = row;
      this.onShowDetails = true;
    },
    finish() {
      this.onShowDetails = false;
    }
  },
  components: {
    DataGrid,
    "v-select": vSelect,
    datePicker: VuePersianDatetimePicker,
    DetailsPopup
  }
};
</script>
